
import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface WelcomeBannerProps {
  title: string;
  description: string;
  ctaLabel: string;
  onCtaClick: () => void;
}

export function WelcomeBanner({ 
  title, 
  description, 
  ctaLabel, 
  onCtaClick 
}: WelcomeBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  
  useEffect(() => {
    const dismissed = localStorage.getItem('welcomeBannerDismissed');
    if (dismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);
  
  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsDismissed(true);
      localStorage.setItem('welcomeBannerDismissed', 'true');
    }, 300);
  };
  
  if (isDismissed) {
    return null;
  }
  
  return (
    <div className={`relative glass-card p-4 mb-6 rounded-lg shadow-sm border border-primary/10 animate-in ${isVisible ? 'fade-in slide-in-from-top-4' : 'fade-out slide-out-to-top-4'} duration-300`}>
      <button 
        onClick={handleDismiss}
        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Dismiss welcome message"
      >
        <X className="h-4 w-4" />
      </button>
      
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
          <h3 className="font-semibold text-lg mb-1">{title}</h3>
          <p className="text-muted-foreground text-sm">{description}</p>
        </div>
        <Button onClick={onCtaClick} size="sm" className="whitespace-nowrap">
          {ctaLabel}
        </Button>
      </div>
    </div>
  );
}
